module.exports = __webpack_public_path__ + "static/media/41-6.b55fd758.mp3";